<template>
    <v-container>
        <table-basic-info class="table-container" :items="itemsInfo"/>
        <v-row align="center">
            <v-col cols="11" md="12" align="center">
                <v-btn
                    v-for="(button,i) in buttons"
                    :key="i"
                    class="kimsa-elevation normal-btn button-container"
                    text color="accent"
                    @click="onActionButton(button.action)"
                >
                    {{ button.name }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="9" lg="8">
                <select-option-students @change="option = $event"/>
                <v-data-table
                    :headers="headers"
                    :loading="loading"
                    :items="students"
                    :items-per-page="10"
                    @page-count="pageCount = $event"
                    :page.sync="page"
                    :mobile-breakpoint="0"
                    hide-default-footer
                    :search="search"
                    sort-by="status"
                    :loading-text="$t('common.loading')"
                    :no-data-text="$t('common.not_found')"
                >
                    <template v-slot:item="{ item }">
                        <tr class="kimsa-elevation">
                            <!-- IMG -->
                            <td style="border: none" class="py-2">
                                <v-avatar color="accent" size="45">
                                    <v-img :src="item.img" :contain="item.img === imgPlaceholder"></v-img>
                                </v-avatar>
                            </td>
                            <!-- NAME -->
                            <td style="border: none">
                                {{ item.name }}
                            </td>
                            <!-- GROUP -->
                            <td style="border: none" v-if="option !== 'team'">
                                <select-group-student-menu
                                    :groups="groups" :student-id="item.id" :student-name="item.name"
                                    :current-group="item.groupId" :disabled="!!item.team || !!item.groupId"
                                    @save="updateGroup($event)"
                                />
                            </td>
                            <!-- TEAM -->
                            <td style="border: none" v-if="option !== 'group'">
                                <select-team-student-menu
                                    :teams="teams" :student-id="item.id" :student-name="item.name"
                                    :current-team="item.team" :disabled="!!item.team || !!item.groupId"
                                    @save="updateGroup($event)"
                                />
                            </td>
                            <!-- STATUS -->
                            <td style="border: none">
                                <div class="text-center">
                                    {{ !item.status ? $t('common.active') : $t('common.inactive') }}
                                    <v-btn :color="!item.status ? 'success' : 'error'" icon @click="changeStatusStudent(item)"
                                           :loading="item.loadingStatus">
                                        <v-icon>{{ !item.status ? 'mdi-check' : 'mdi-close' }}</v-icon>
                                    </v-btn>
                                </div>
                            </td>
                            <!-- BUTTONS -->
                            <td style="border: none">
                                <v-btn v-if="option === 'group' || option === 'team'" class="mr-1 mt-1" fab small depressed
                                       @click="showDeleteStudentConfirm(item)">
                                    <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                                <v-btn class="mr-1 mt-1" fab small depressed @click="toStudentProfile(item.id)">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                                <v-btn class="mr-1 mt-1" fab small depressed @click="toAssignProgram(item.id)">
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:footer>
                        <v-row no-gutters>
                            <v-col cols="12" md="4" lg="7">
                                <kimsa-text-field
                                    class="mt-2 ml-3"
                                    @change="search = $event"
                                    :value="search"
                                    placeholder="Buscar..."
                                    color="grey" dense outlined
                                />
                            </v-col>
                            <v-col cols="12" md="8" lg="5">
                                <kimsa-pagination
                                    v-if="pageCount > 0"
                                    @page="page = $event"
                                    :pageCount="pageCount"
                                    :total-visible="isMobile ? 5 : 7"
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>

            </v-col>
            <v-col cols="12" md="3" lg="4" class="px-0">
                <v-sheet color="transparent" height="20" v-if="!isMobile"/>
                <div class="title-section">
                    {{ $tc('common.messages', 2) }}
                </div>
                <chats component-mode/>
            </v-col>
        </v-row>

        <invite-student-dialog ref="invite"/>
        <create-group-students-dialog ref="createGroup"/>
        <create-team-students-dialog ref="createTeam"/>
        <admin-groups-dialog ref="adminGroups"/>

        <kimsa-confirm
            v-if="option === 'group' || option === 'team'"
            ref="delete"
            :title="$t(`common.delete_${option}_title`, {name: student && student.name || ''})"
            :content="$t(`common.delete_${option}_subtitle`, {name: student && student.name || ''})"
            :loading="loadingDelete"
            :persistent="false"
            @confirm="onConfirmDelete"
            @cancel="student = null"
            :close-on-confirm="false"
            :alert-mode="true"
        />

    </v-container>

</template>

<script>

import StudentCard from '@/components/common/cards/StudentCard'
import {UserIndex, Client} from "@/utils/Algolia";
import InviteStudentDialog from "@/components/coach/InviteStudentDialog";
import CreateGroupStudentsDialog from "@/components/coach/CreateGroupStudentsDialog";
import {mapActions, mapState} from "vuex";
import SelectGroupStudentMenu from "@/components/coach/SelectGroupStudentMenu";
import CreateTeamStudentsDialog from "@/components/coach/CreateTeamStudentsDialog";
import SelectTeamStudentMenu from "@/components/coach/SelectTeamStudentMenu";
import {db} from "@/utils/Firebase";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import {getAllGroupAssignedRoutines, getAllStudentAssignedRoutines} from "@/utils/Exercises";
import TableBasicInfo from "@/components/elements/table/TableBasicInfo";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaPagination from "@/components/common/KimsaPagination";
import SelectOptionStudents from "@/components/coach/SelectOptionStudents";
import Chats from "@/views/coach/Chats";
import AdminGroupsDialog from "@/components/coach/AdminGroupsDialog";

export default {
    components: {
        AdminGroupsDialog,
        Chats,
        SelectOptionStudents,
        KimsaPagination,
        KimsaTextField,
        TableBasicInfo,
        KimsaConfirm,
        KimsaCombobox,
        SelectTeamStudentMenu,
        CreateTeamStudentsDialog,
        SelectGroupStudentMenu,
        CreateGroupStudentsDialog,
        InviteStudentDialog,
        StudentCard,
    },
    data(vm = this) {
        return {
            students: [],
            loading: false,
            option: 'all',
            student: null,
            loadingDelete: false,
            search: '',
            page: 1,
            pageCount: 0,
            buttons: [
                {name: vm.$t('coach.invite_student'), action: 'showInviteDialog'},
                {name: vm.$t('common.add_group'), action: 'showCreateGroupDialog'},
                {name: vm.$t('common.add_team'), action: 'showCreateTeamDialog'},
                {name: vm.$t('common.admin_teams_groups'), action: 'showGroupsListDialog'},
            ]
        }
    },
    async mounted() {
        const vm = this
        if (vm.groups.length === 0) await vm.bindGroups(vm.currentUser.uid)
        if (vm.teams.length === 0) await vm.bindTeams(vm.currentUser.uid)
        await vm.loadStudents()
    },
    computed: {
        ...mapState(['groups', 'teams']),
        headers(vm = this) {
            let headers = [
                {text: '', value: 'img', sortable: false},
                {text: vm.$t('common.name'), value: 'name'},
                {text: vm.$t('common.group'), value: 'group'},
                {text: vm.$t('common.team'), value: 'team'},
                {text: vm.$t('common.status'), value: 'status'},
                {text: '', value: 'actions', sortable: false},
            ]
            if (vm.option === 'group') headers = headers.filter(header => header.value !== 'team')
            if (vm.option === 'team') headers = headers.filter(header => header.value !== 'group')
            return headers
        },
        itemsInfo(vm = this) {
            return [
                {name: vm.$t('coach.active_students'), value: vm.account?.activeStudents || 0},
            ]
        }
    },
    methods: {
        ...mapActions(['bindGroups', 'bindTeams']),
        async loadStudents() {
            const vm = this
            vm.loading = true
            vm.students = []

            let filter = `studentSubscription.coachId: ${vm.currentUser.uid}`
            // console.log('search students', filter)

            await Client.clearCache()
            await UserIndex.search('', {
                filters: filter,
                hitsPerPage: 10000
            })
                .then(({hits}) => {
                    vm.students = hits.filter(hit => {
                        if (vm.option === 'group') return !!hit.group
                        if (vm.option === 'team') return !!hit.team
                        if (vm.option === 'student') return !hit.group && !hit.team
                        return hit
                    }).map(hit => {
                        let status = Boolean(hit.studentSubscription.paused)
                        if (hit.studentSubscription.paused === undefined) status = false

                        return {
                            id: hit.objectID,
                            name: hit.name,
                            email: hit.email,
                            img: hit.avatar || vm.imgPlaceholder,
                            groupId: hit.group || null,
                            team: hit.team || null,
                            status: status,
                            loadingStatus: false,
                        }
                    })
                    // console.log('students', vm.students)
                    // console.log('hits',hits)
                    vm.loading = false
                })
                .catch(err => {
                    console.log(err);
                });
        },
        toStudentProfile(studentId) {
            const vm = this
            vm.$router.push({name: 'coach.students.profile', params: {uid: studentId}})
        },
        toAssignProgram(studentId) {
            const vm = this
            vm.$router.push({name: 'coach.routines', query: {tabs: 'programs', studentId: studentId}})
        },
        showInviteDialog() {
            const vm = this
            vm.$refs.invite.show()
        },
        showCreateGroupDialog() {
            const vm = this
            vm.$refs.createGroup.show()
        },
        showCreateTeamDialog() {
            const vm = this
            vm.$refs.createTeam.show()
        },
        showGroupsListDialog() {
            const vm = this
            vm.$refs.adminGroups.show()
        },
        updateGroup(studentId) {
            const vm = this
            let studentIndex = vm.students.findIndex(student => student.id === studentId)
            if (studentIndex >= 0) vm.students.splice(studentIndex, 1)
        },
        async changeStatusStudent(student) {
            student.loadingStatus = true
            let newStatus = !student.status
            await db.collection('users').doc(student.id).update({'studentSubscription.paused': newStatus})
            student.status = newStatus
            student.loadingStatus = false
        },
        showDeleteStudentConfirm(student) {
            const vm = this
            vm.student = student
            vm.$refs.delete.show()
        },
        async onConfirmDelete() {
            const vm = this
            let studentIndex = vm.students.findIndex(st => st.id === vm.student.id)
            if (studentIndex >= 0) {
                // console.log('student', vm.student)
                vm.loadingDelete = true

                await vm.clearGroupRoutinesIds()

                if (vm.option === 'group') {
                    let currentGroup = vm.groups?.find(group => group.id === vm.student.groupId)
                    let students = currentGroup.students.filter(st => st !== vm.student.id)
                    await db.collection('users').doc(vm.student.id).update({group: null})
                    await db.collection('groups').doc(vm.student.groupId).update({students: students})
                } else if (vm.option === 'team') {
                    let currentTeam = vm.teams?.find(team => team.id === vm.student.team.id)
                    let currentGroup = currentTeam?.groups?.find(group => vm.student.team.subgroupId === group.id)
                    let students = currentGroup.students.filter(st => st !== vm.student.id)
                    let groups = JSON.parse(JSON.stringify(currentTeam?.groups))
                    let findGroupIndex = currentTeam?.groups?.findIndex(group => group.id === vm.student.team.subgroupId || null)
                    groups[findGroupIndex].students = students
                    await db.collection('users').doc(vm.student.id).update({team: null})
                    await db.collection('teams').doc(vm.student.team.id).update({groups: groups})
                }

                vm.students.splice(studentIndex, 1)
                vm.loadingDelete = false
            }
            vm.$refs.delete.hide()
        },
        async clearGroupRoutinesIds() {
            const vm = this

            let groupRoutines = await getAllGroupAssignedRoutines(vm.student.groupId)
            let studentRoutines = await getAllStudentAssignedRoutines(vm.student.id)

            let studentRoutinesIds = studentRoutines.map(routine => {
                return routine.id
            })

            for (let groupRoutine of groupRoutines) {
                for (let id of groupRoutine.assignedRoutinesIds) {
                    if (studentRoutinesIds.includes(id)) {
                        await db.collection('groupAssignedRoutines').doc(groupRoutine.id).update({assignedRoutinesIds: groupRoutine.assignedRoutinesIds.filter(arId => arId !== id)})
                        break;
                    }
                }
            }
        },
        goToGroupsList() {
            const vm = this
            vm.$router.push({name: 'coach.students.groups'})
        },
        onActionButton(method) {
            this[method]()
        }
    },
    watch: {
        option() {
            this.loadStudents()
        }
    }
}
</script>

<style scoped>

.table-container {
    position: absolute;
    top: 0;
    right: 0;
    text-align: right !important;
    box-shadow: none !important;
}

.button-container {
    border: 1px solid currentColor;
    border-radius: 0;
}

.button-container:hover {
    background: var(--v-accent-base);
    color: #FFFFFF !important;
}

>>>.v-data-table-header > tr {
    box-shadow: 3px 3px 6px 0 rgba(1, 55, 46, 0.1) !important;
}

>>>.v-data-table-header > tr > th {
    border: none !important;
}

>>>.v-data-table-header > tr > th > span {
    font-weight: bold !important;
}

.title-section {
    font-size: 18px;
    font-weight: bold;
    color: #666666;
    padding: 8px;
}

</style>
